import log from 'pathfinder/utils/log';
const targetingDebug = (message, step, data) => {
    const debugMessage = `NotificationsTargeting [Step ${step.join('.')}] ${message}:`;
    log.debug(debugMessage, data);
};
export default targetingDebug;
